import Reflux from 'reflux';

const RefreshActions = Reflux.createActions([
  'changeInterval',
  'disable',
  'enable',
]);

export default RefreshActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/tools/RefreshActions.jsx